<template>
  <div class="bid-row">
    <f7-link @click="callTeamDetail" style="width: 100%;">
      <div class="bid-row-container">
        <div class="bid-team-logo" v-if="team.logoId">
          <img style="width: 2.5rem; height: 2.5rem;"
            :src="imageUrl+'?attachmentId='+team.logoId"/>
        </div>
        <div class="bid-team-content">
          <div style="display: flex; align-items: start;">
            <div class="bid-title">
              {{ team.name }}
            </div>
            <competitiveness :score="team.score"></competitiveness>
          </div>
          <div class="bid-team-area">
            <div class="team-auth" v-if="team.companyStatus === '30'">
              <span>已认证</span>
            </div>
            <div>{{ team.areas.map(item => item.nameDesc).join('，') }}</div>
          </div>
          <div class="bid-team-features">
            <div
              class="bid-team-feature-text"
              v-for="item in team.features"
              :key="item.type+item.name"
              v-if="item.nameDesc && item.nameDesc !== ''">
              {{ item.nameDesc }}
            </div>
          </div>
        </div>
      </div>
    </f7-link>
  </div>
</template>
<script>
import { toTeamDetail } from '@/util/native';
import { imageView } from '@/api/common';
import Competitiveness from '@/components/Competitiveness';

export default {
  props: ['team'],
  components: {
    Competitiveness,
  },
  data() {
    return {
      imageUrl: imageView,
    };
  },
  methods: {
    callTeamDetail() {
      toTeamDetail(this.team.id);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .bid-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 0.5rem 0rem;
  }

  .bid-row-container {
    display: flex;
    justify-content: flex-start;
  }

  .bid-team-logo {
    width: 4rem;
    height: 4rem;
  }

  .bid-team-content {
    flex: auto;
  }

  .bid-title {
    font-size: 1rem;
    padding: 0rem 0rem 0rem 0rem;
  }

  .bid-team-area {
    display: flex;
    justify-content: flex-start;
    padding: 0.5rem 0rem;
  }

  .team-auth {
    min-width: 2.5rem;
    margin-right: 0.3rem;
    padding: 0rem 0.2rem;
    height: 1rem;
    font-size: 0.8rem;
    border: 0.05rem solid $red-color;
    border-radius: 0.2rem;
    color: $red-color;
  }

  .bid-features {
    display: flex;
    flex-wrap: wrap;
    font-size: 0.85rem;
    padding: 0.1rem 0rem;
  }

  .bid-team-feature-text {
    display: inline-block;
    margin: 0rem 0.5rem 0rem 0rem;
    background-color: $panel-bg-color;
    height: 1rem;
    line-height: 1rem;
    padding: 0rem 0.2rem;
    border-radius: 0.2rem;
    color: $second-font-color;
  }

</style>



// WEBPACK FOOTER //
// src/components/BidTeam.vue